/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type siteQueryVariables = {};
export type siteQueryResponse = {
    readonly blogCollection: {
        readonly items: ReadonlyArray<{
            readonly sys: {
                readonly firstPublishedAt: string | null;
                readonly id: string;
            };
            readonly title: string | null;
            readonly blogContent: {
                readonly json: string;
            } | null;
        } | null>;
    } | null;
};
export type siteQuery = {
    readonly response: siteQueryResponse;
    readonly variables: siteQueryVariables;
};



/*
query siteQuery {
  blogCollection(order: sys_firstPublishedAt_DESC) {
    items {
      sys {
        firstPublishedAt
        id
      }
      title
      blogContent {
        json
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": "sys_firstPublishedAt_DESC"
      }
    ],
    "concreteType": "BlogCollection",
    "kind": "LinkedField",
    "name": "blogCollection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Blog",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstPublishedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogBlogContent",
            "kind": "LinkedField",
            "name": "blogContent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "json",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "blogCollection(order:\"sys_firstPublishedAt_DESC\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "siteQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "siteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c9447f9b64c9d23ecb58b5eda057afc1",
    "id": null,
    "metadata": {},
    "name": "siteQuery",
    "operationKind": "query",
    "text": "query siteQuery {\n  blogCollection(order: sys_firstPublishedAt_DESC) {\n    items {\n      sys {\n        firstPublishedAt\n        id\n      }\n      title\n      blogContent {\n        json\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '24a9fab2c030d5ad4e41d078913ce738';
export default node;
